import { render } from "./ServerReportView.vue?vue&type=template&id=38a643b0"
import script from "./ServerReportView.vue?vue&type=script&lang=js"
export * from "./ServerReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Agent/ServerReportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38a643b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38a643b0', __exports__)) {
    api.reload('38a643b0', __exports__)
  }
  
  module.hot.accept("./ServerReportView.vue?vue&type=template&id=38a643b0", () => {
    api.rerender('38a643b0', render)
  })

}


export default __exports__